import { useTheme } from "../context/ThemeContext";

export default function HealthBar({ value }) {
  const { mode } = useTheme();
  const color = value >= 80 ? "var(--green)" : value >= 50 ? "var(--amber)" : value > 0 ? "var(--red)" : "var(--text-dim)";
  return (
    <div style={{ display:"flex", alignItems:"center", gap:7 }}>
      <div style={{ width:52, height:3, background:"var(--surface-alt)", borderRadius:2, overflow:"hidden" }}>
        <div style={{ width:`${value}%`, height:"100%", background:color, borderRadius:2 }} />
      </div>
      <span style={{ fontSize:11, color:"var(--text-sub)", fontVariantNumeric:"tabular-nums" }}>{value}%</span>
    </div>
  );
}
